/**
 * Run state machine.
 *
 *   READY    - player is at the bed, timer at 00:00.000, waiting for W/A/S/D/Space
 *   RUNNING  - timer is advancing, simulation is stepping
 *   FINISHED - player sat down at their own seat, timer stopped
 *   PAUSED   - pointer lock released (Esc), simulation frozen
 */
export const RunState = {
  Ready: 'READY',
  Running: 'RUNNING',
  Finished: 'FINISHED',
  Paused: 'PAUSED',
} as const;

export type RunState = (typeof RunState)[keyof typeof RunState];

/** Only RUNNING advances the simulation clock. */
export function isSimulating(state: RunState): boolean {
  return state === RunState.Running;
}
